/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectRuntimeStatus
 */
export interface ProjectRuntimeStatus {
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    phase?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    lastPublishedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    nextScheduledRunAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    nextScheduledRunMode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    activeRunId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    activeRunMode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    queuedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    startedAt?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProjectRuntimeStatus
     */
    since?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ProjectRuntimeStatus
     */
    until?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectRuntimeStatus
     */
    canManualRebuild?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectRuntimeStatus
     */
    error?: string | null;
}

/**
 * Check if a given object implements the ProjectRuntimeStatus interface.
 */
export function instanceOfProjectRuntimeStatus(value: object): value is ProjectRuntimeStatus {
    return true;
}

export function ProjectRuntimeStatusFromJSON(json: any): ProjectRuntimeStatus {
    return ProjectRuntimeStatusFromJSONTyped(json, false);
}

export function ProjectRuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'status': json['status'] == null ? undefined : json['status'],
        'phase': json['phase'] == null ? undefined : json['phase'],
        'lastPublishedAt': json['lastPublishedAt'] == null ? undefined : json['lastPublishedAt'],
        'nextScheduledRunAt': json['nextScheduledRunAt'] == null ? undefined : json['nextScheduledRunAt'],
        'nextScheduledRunMode': json['nextScheduledRunMode'] == null ? undefined : json['nextScheduledRunMode'],
        'activeRunId': json['activeRunId'] == null ? undefined : json['activeRunId'],
        'activeRunMode': json['activeRunMode'] == null ? undefined : json['activeRunMode'],
        'queuedAt': json['queuedAt'] == null ? undefined : json['queuedAt'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'since': json['since'] == null ? undefined : (new Date(json['since'])),
        'until': json['until'] == null ? undefined : (new Date(json['until'])),
        'canManualRebuild': json['canManualRebuild'] == null ? undefined : json['canManualRebuild'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function ProjectRuntimeStatusToJSON(json: any): ProjectRuntimeStatus {
    return ProjectRuntimeStatusToJSONTyped(json, false);
}

export function ProjectRuntimeStatusToJSONTyped(value?: ProjectRuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectId': value['projectId'],
        'status': value['status'],
        'phase': value['phase'],
        'lastPublishedAt': value['lastPublishedAt'],
        'nextScheduledRunAt': value['nextScheduledRunAt'],
        'nextScheduledRunMode': value['nextScheduledRunMode'],
        'activeRunId': value['activeRunId'],
        'activeRunMode': value['activeRunMode'],
        'queuedAt': value['queuedAt'],
        'startedAt': value['startedAt'],
        'since': value['since'] == null ? value['since'] : value['since'].toISOString().substring(0,10),
        'until': value['until'] == null ? value['until'] : value['until'].toISOString().substring(0,10),
        'canManualRebuild': value['canManualRebuild'],
        'error': value['error'],
    };
}

